<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Close Button -->
    <button class="close-button" (click)="onClose()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <h2 class="modal-title">Mark this appointment complete?</h2>
    <!-- Modal Content -->
    <div class="modal-content">
    
      <p class="modal-message">
        Are you sure you want to mark this appointment complete? This action is permanent and cannot be undone.
      </p>
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions">
      <div class="mobile-order">
        <button class="btn btn-secondary btn-large" (click)="onCancel()">
          Cancel
        </button>
      </div>
      <div>
        <button class="btn btn-primary btn-large" (click)="onConfirm()">
          Mark Complete
        </button>
      </div>
    </div>
  </div>
</div>
